import { cardData } from "../constants/card-constant";
import Card from "./card/Card";

import "./style.scss";

export const App = () => {
	return (
		<div className="app-description">
			{cardData.map((card) => (
				<Card key={card.description} data={card} />
			))}
		</div>
	);
};

export default App;
